<div class="loader-wrapper brand-dashboard-wrapper">
  <section>
    <h3>{{ "brand.campaign.map.title" | translate }}</h3>
    <div class="dashboard-map" #gmap></div>
  </section>
  <app-loader
    [text]="'shared.loadingCampaign' | translate"
    [ngClass]="{ visible: loading }"
  />
</div>
